<div class="list-container">
    <dynamic-table [props]="props">
        <table class="table">
            <thead>
                <tr class="table-header">
                    <th id="Number" class="table-header-title">{{'invoice.number' | translate}}</th>

                    <th id="IssuedDate" class="table-header-title">{{'invoice.issuedDate' | translate}}</th>

                    <th id="DueDate" class="table-header-title">{{'invoice.dueDate' | translate}}</th>

                    <th id="Type" class="table-header-title">{{'invoice.type' | translate}}</th>

                    <th id="Categories" class="table-header-title">{{'invoice.category' | translate}}</th>

                    <th id="Contracts" class="table-header-title">{{'invoice.contract' | translate}}</th>

                    <th id="Value" class="table-header-title">{{'invoice.value' | translate}}</th>

                    <th id="OutstandingAmount" class="table-header-title">
                        {{'invoice.outstandingAmount' | translate}}
                    </th>

                    <th id="IsPaid" class="table-header-title">{{'invoice.status.title' | translate}}</th>
                </tr>
            </thead>

            <tbody>
                <ng-container *ngFor="let invoice of invoices">
                    <tr class="row-container ccc ccc-table-row ccc-hover" role="button"
                        [ngClass]="{'border-not-paid': !invoice?.isPaid, 'overdue-row-color': invoice?.isOverdue}"
                        (click)="navigateToDetailHandler(invoice.invoiceId)">
                        <td id="Number" class="invoice-number column-content fw-bold">
                            <div class="d-flex align-items-center justify-content-center">
                                <span HJSuppress class="text-ellipsis"
                                    textEllipsisToTooltip ngbTooltip=""
                                    [ngClass]="[invoice?.isOverdue ? 'overdue-color' : 'not-paid-color']">
                                    {{invoice?.number}}
                                </span>
                                <button class="btn copy-clipboard-btn custom-copy-clipboard-btn ms-2" [cdkCopyToClipboard]="invoice?.number" 
                                    (click)="showClipboardNotification($event)">
                                    <i class="app-icon icon icon-copy icon-md2"></i>
                                </button>
                            </div>
                        </td>

                        <td HJSuppress id="IssuedDate" class="column-content">
                            {{invoice?.issuedDate | localizedDate}}
                        </td>

                        <td HJSuppress id="DueDate" class="column-content fw-bold">
                            {{invoice?.dueDate | localizedDate}}
                        </td>

                        <td HJSuppress id="Type" class="column-content">
                            {{invoice?.type}}
                        </td>

                        <td id="Categories" class="column-content">
                            <div *ngIf="invoice?.categories?.length > 0" class="d-flex flex-column">
                                <div HJSuppress *ngFor="let category of invoice?.categories | slice: 0 : 2">
                                    {{category}}
                                </div>
                                <button *ngIf="invoice?.categories?.length > 2" 
                                    type="button" class="btn view-more-btn"
                                    (click)="openDetailsListModalInvoiceCategories($event, invoice?.categories)"
                                >
                                    {{'common.viewMore' | translate}}
                                </button>
                            </div>
                        </td>

                        <td id="Contracts" class="column-content">
                            <div *ngIf="invoice?.contracts?.length > 0" class="d-flex flex-column">
                                <div HJSuppress *ngFor="let contract of invoice?.contracts | slice: 0 : 2" >
                                    {{contract}}
                                </div>
                                <button *ngIf="invoice?.contracts?.length > 2" 
                                    type="button" class="btn view-more-btn"
                                    (click)="openDetailsListModalInvoiceContracts($event, invoice?.contracts)">
                                    {{'common.viewMore' | translate}}
                                </button>
                            </div>
                        </td>

                        <td HJSuppress id="Value" class="column-content fw-bold">
                            {{invoice?.totalWithVAT | number : '1.'}} {{invoice?.currencyCode}}
                        </td>

                        <td HJSuppress id="OutstandingAmount" class="column-content fw-bold">
                            {{invoice?.outstandingAmount | number : '1.' | replaceIfNull}}
                            <ng-container *ngIf="invoice?.outstandingAmount !== null">
                                {{invoice?.currencyCode}}
                            </ng-container>
                        </td>
                        
                        <td HJSuppress id="IsPaid" class="column-content">
                            <div *ngIf="invoice?.isPaid" class="state d-flex align-items-center justify-content-center">
                                <i class="app-icon icon icon-check-circle-fill icon-xl paid-icon me-2"></i>
                                {{'invoice.status.paid' | translate}}
                            </div>
                            <div *ngIf="!invoice?.isPaid && !invoice?.isOverdue" class="state d-flex align-items-center justify-content-center">
                                <i class="app-icon icon icon-close-circle-fill icon-xl not-paid-icon me-2"></i>
                                {{'invoice.status.notPaid' | translate}}
                            </div>
                            <div *ngIf="invoice?.isOverdue" class="overdue-color state d-flex align-items-center justify-content-center">
                                <i class="app-icon icon icon-warning-triangle-fill icon-xl overdue-icon me-2"></i>
                                {{'invoice.status.overdue' | translate}}
                            </div>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </dynamic-table>
</div>

